import "./ImageCard.css";

export const ImageCard = ({ card }) => {
  const { image, likes, comments, tags } = card;

  return (
    <div className="container">
      <div className="image-container">
        <img className="source-img" src={image} alt="src" />
      </div>
      <div className="tags">
        <span className="tag-color">Tags - {tags}</span>
      </div>
      <div className="likes-comments">
        <span>{likes} Likes</span>
        <span>{comments} Comments </span>
      </div>
    </div>
  );
};
